export const sanitizePhoneNumber = (value) =>
    String(value || "").replace(/\D/g, "");

export const isValidPhoneNumber = (
    value,
    { minLength = 10, maxLength = 15 } = {},
) => {
    const digits = sanitizePhoneNumber(value);
    return digits.length >= minLength && digits.length <= maxLength;
};
